export const EXPERIMENT_VARIANTS = {
  CONTROL: 'control',
  TREATMENT: 'treatment',
} as const;

export const HOME_ACCOUNT_NUDGE_EXPERIMENT_KEY = 'home_account_nudge';
